'use strict';

export function signOut(event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    if (process.env.CIAM_LOGIN_ENABLED === 'true') {
        let logoutUrl = `${process.env.CIAM_LOGOUT_URL}logout?client_id=${process.env.CIAM_CLIENT_ID}&returnTo=${process.env.CIAM_AUTH_LOGOUT_CALLBACK}`;
        window.location.href = logoutUrl;
    } else {
        // The MUI app bar does not render the legacy `#signout-form`,
        // so POST to the sign-out route directly to clear the session cookies.
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/accounts/sign-out';
        document.body.appendChild(form);
        form.submit();
    }
}

export default signOut;
